export { GraphemeMorphemePanelsView } from "#grapheme-morpheme-panels-view";
